import T from 'i18n-react';
import { FEMALE, MALE } from '../variables';
import BoyImage from '../../../images/plans/boy.png';
import sample from 'lodash/sample';
import Girl1Image from '../../../images/plans/girl_1.png';
import Girl2Image from '../../../images/plans/girl_2.png';
import DefaultImage from '../../../images/admin/default.png';
import moment from 'moment';

export const getName = (sex, age) =>
  [
    T.translate(sex, { notFound: '' }),
    age > 0 ? T.translate('generation', { age }) : false,
  ]
    .filter((e) => e)
    .join(' ');

export const getImageSrc = (sex) => {
  if (sex === MALE) {
    return BoyImage;
  } else if (sex === FEMALE) {
    return sample([Girl1Image, Girl2Image]);
  }
  return DefaultImage;
};

export const getParticipantJoinTime = (startsAt) => {
  const m = moment(startsAt, 'YYYY-MM', true);
  if (!m.isValid()) return;

  return T.translate('joinTime', {
    year: m.format('YYYY'),
    month: m.format('M'),
  });
};
